<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>devices_other</md-icon>
          </template>
          <template slot="content">
            <p class="category">Devices</p>
            <h3 class="title">{{ devices.length }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <a
                :class="{
                  'cursor-class': !isReadOnly,
                  'show-add-user-deleted-app': isReadOnly,
                }"
              >
                <md-icon>add</md-icon>
                Add New Device
              </a>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>warning</md-icon>
          </template>

          <template slot="content">
            <p class="category">Unsuccessful Auth.</p>

            <h3 class="title" v-if="user.lastUnsuccessfulLogin.date">
              {{ user.lastUnsuccessfulLogin.count }}
              <small>since {{ lastLoginDate }}</small>
            </h3>
            <h3 class="title" v-else>
              {{ user.lastUnsuccessfulLogin.count }}
              <small>since activation</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>keyboard_arrow_right</md-icon>
              <router-link
                :to="{
                  name: 'Authentication/Authorization Reports',
                  query: {
                    application_user_pk: this.$route.query.user_pk,
                    application_username: this.user.username
                  }
                }"
                >Proceed to Logs
              </router-link>
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>assignment_turned_in</md-icon>
          </template>

          <template slot="content">
            <p class="category">Successful Auth.</p>
            <h3 class="title">
              {{ (user.allow * 100).toFixed(2) }}
              <small>% ({{ user.deny }} denies)</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>keyboard_arrow_right</md-icon>
              <router-link
                :to="{
                  name: 'Authentication/Authorization Reports',
                  query: {
                    application_user_pk: this.$route.query.user_pk,
                    application_username: this.user.username
                  }
                }"
                >Proceed to Logs
              </router-link>
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="red">
          <template slot="header">
            <md-icon>assignment_late</md-icon>
          </template>

          <template slot="content">
            <p class="category">Frauds</p>
            <h3 class="title">{{ user.frauds }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>keyboard_arrow_right</md-icon>
              <router-link
                :to="{
                  name: 'Authentication/Authorization Reports',
                  query: {
                    application_user_pk: this.$route.query.user_pk,
                    application_username: this.user.username
                  }
                }"
                >Proceed to Logs
              </router-link>
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-65">
        <nav-tabs-card>
          <template slot="content">
            <span class="md-nav-tabs-title">User</span>
            <md-tabs class="md-primary" md-alignment="right">
              <md-tab id="tab-home" md-label="Devices" md-icon="devices">
                <div style="display: flex; justify-content: space-between">
                  <md-button v-if="!isReadOnly" class="md-button" @click="showCreateDevice()">
                    <md-icon> add </md-icon>
                    Create new device
                  </md-button>
                  <div class="md-alignment-center-right">
                    <on-off-button
                      mode="switch"
                      switch-text="Hide/Show revoked"
                      @click="showHideRevokedDevices"
                    ></on-off-button>
                  </div>
                </div>
                <md-card-content>
                  <md-table v-model="devices" table-header-color="purple" md-card>
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="">
                        <i :class="item.type_fa">
                          <md-tooltip md-direction="top">{{ item.type }}</md-tooltip>
                        </i>
                      </md-table-cell>
                      <md-table-cell md-label="Device ID">
                        <span v-if="item.device.length <= 17">{{ item.device }}</span>
                        <span v-else>{{ item.device.substring(0, 17) }}...</span>
                      </md-table-cell>
                      <md-table-cell md-label="Name">
                        <span v-if="item.name.length <= 17">{{ item.name }}</span>
                        <span v-else>{{ item.name.substring(0, 17) }}...</span>
                      </md-table-cell>
                      <md-table-cell class="table-actions">
                        <md-button
                          v-if="item.locked"
                          class="md-icon-button md-dense"
                          @click.prevent="unlockDevice(item)"
                        >
                          <md-icon>lock</md-icon>
                          <md-tooltip md-direction="top">Unlock Device</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-dense" @click.prevent="showDeviceDetails(item)">
                          <md-icon>more_vert</md-icon>
                          <md-tooltip md-direction="top">More Details</md-tooltip>
                        </md-button>
                        <md-button
                          class="md-icon-button md-dense"
                          @click.prevent="showRevokeDevice(item)"
                          :disabled="!item.confirmed || isReadOnly"
                        >
                          <md-icon>delete</md-icon>
                          <md-tooltip md-direction="top">Revoke Device</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-dense" @click.prevent="goToLogsForDevice(item.device)">
                          <md-icon>history</md-icon>
                          <md-tooltip md-direction="top">Logs</md-tooltip>
                        </md-button>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-tab>

              <md-tab id="tab-pages" md-label="Policies" md-icon="policy">
                <policy-table
                  :query="{ applicationUserPk: this.$route.query.user_pk }"
                  :scopeName="user.username"
                ></policy-table>
              </md-tab>
            </md-tabs>
          </template>
        </nav-tabs-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-35">
        <md-card class="md-card-profile">
          <div class="md-card-avatar">
            <md-icon class="md-size-5x">account_circle</md-icon>
          </div>

          <md-card-content>
            <h6 class="category text-gray">
              {{ user.userID.substring(0, 10) }}...
              <md-tooltip>{{ user.userID.substring(0, 20) }}...</md-tooltip>
            </h6>
            <h4 class="card-title">{{ user.username }}</h4>
            <md-button :disabled="isReadOnly" class="md-primary" @click="showDeleteUser" v-if="user.state !== 'DT'">
              <md-icon>delete</md-icon>
              Delete User
            </md-button>
          </md-card-content>
        </md-card>
        <md-card v-if="user.state !== 'DT'" class="security-card">
          <md-card-content>
            <md-subheader class="md-layout" style="padding: 0;">
              <div class="md-layout-item md-size-70 ">MFA Settings</div>
              <div class="md-layout-item md-size-30 text-right">
                <md-switch :disabled="isReadOnly" v-model="policyEnabled" @change="enableDisableMFASettings()">
                  Enable
                </md-switch>
              </div>
            </md-subheader>
            <transition name="fade">
              <md-list-item v-if="policyEnabled">
                <policy-slider v-model="policy" :disabled="!policyEnabled || isReadOnly"></policy-slider
                ><md-button
                  class="md-icon-button md-list-action"
                  @click="setPolicy"
                  :disabled="!policyEnabled || isReadOnly"
                >
                  <md-icon>save</md-icon>
                </md-button>
              </md-list-item>
            </transition>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <device-details
      :show="showDeviceDetailsDialog"
      :device="currentDevice"
      :application_user_pk="this.$route.query.user_pk"
      @close="hideDeviceDetails"
      @save="saveDevice"
    ></device-details>

    <revoke-device
      v-if="!isReadOnly"
      :show="revoke.showRevokeDeviceDialog"
      :device="revoke.currentDevice"
      @close="closeRevokeDialog"
    ></revoke-device>

    <create-new-device
      v-if="!isReadOnly"
      :application_user_id="$route.query.user_pk"
      :show="createDevice.show"
      @close="closeCreateDevice"
    ></create-new-device>
    <delete-user
      v-if="!isReadOnly"
      @deleted="userDeleted"
      @close="deleteUserData.showDeleteUser = false"
      @failed="operationFailed"
      :application_user_pk="$route.query.user_pk"
      :show="deleteUserData.showDeleteUser"
    ></delete-user>
  </div>
</template>
<script>
import { DeviceDetails, NavTabsCard, StatsCard } from "@/components";
import fetchErrorHandler from "../../error.js";
import * as moment from "moment";
import RevokeDevice from "../../components/RevokeDevice";
import CreateNewDevice from "../../components/CreateNewDevice";
import PolicySlider from "@/components/PolicySlider";
import DeleteUser from "@/components/DeleteUser";
import OnOffButton from "@/components/OnOffButton";
import PolicyTable from "@/components/Policies/PolicyTable.vue";

export default {
  name: "user-management",
  components: {
    PolicyTable,
    NavTabsCard,
    PolicySlider,
    CreateNewDevice,
    RevokeDevice,
    StatsCard,
    DeviceDetails,
    DeleteUser,
    OnOffButton,
  },
  props: [],
  data: function() {
    return {
      user: {
        applicationName: "",
        userID: "",
        username: "",
        devCnt: 0,
        allow: 0,
        deny: 0,
        frauds: 0,
        lastUnsuccessfulLogin: {
          count: 0,
          date: ""
        }
      },
      currentSort: "name",
      currentSortOrder: "asc",
      mail: "",
      smsPhoneNumber: "",
      devices: [],
      currentDevice: {},
      onlyActiveDevices: true,
      showDeviceDetailsDialog: false,
      revoke: {
        showRevokeDeviceDialog: false,
        currentDevice: null
      },
      createDevice: {
        show: false
      },
      deleteUserData: {
        showDeleteUser: false
      },
      policy: "",
      policyEnabled: false
    };
  },
  computed: {
    lastLoginDate: function() {
      return moment(this.user.lastUnsuccessfulLogin.date, "YYYYMMDD").fromNow();
    },
    isReadOnly() {
      return window.localStorage.getItem("adminGroups").includes("viewer_admins");
    },
  },
  methods: {
    getPolicies: async function() {
      const response = await this.$api.getPolicies({
        params: {
          application_user_pk: this.$route.query.user_pk
        }
      });
      this.policy = response.parsedData.action === "allow" ? "bypass" : response.parsedData.action;
      this.policyEnabled = response.parsedData.enabled;
    },
    setPolicy: async function() {
      const response = await this.$api.setPolicy({
        params: {
          application_user_pk: this.$route.query.user_pk,
          action: this.policy === "bypass" ? "allow" : this.policy
        }
      });
      if (response.status === 200) {
        this.$notify({
          message: "Successfully updated! ",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success"
        });
        this.policyEnabled = response.parsedData.enabled;
      }
    },
    enableDisableMFASettings: async function() {
      String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
      };

      const response = await this.$api.enableDisableMFASettings({
        params: {
          application_user_pk: this.$route.query.user_pk,
          enabled: this.policyEnabled.toString().capitalize()
        }
      });

      if (response.status !== 200) {
        this.$notify({
          message: "Not updated! ",
          icon: "warning",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
      }
    },
    showCreateDevice() {
      if (this.user.state === "DT") {
        this.$notify({
          message: "Invalid Action For Deleted User",
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return;
      }
      this.createDevice.show = true;
    },
    showDeleteUser() {
      if (this.user.state === "DT") {
        this.$notify({
          message: "Invalid Action For Deleted User",
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return;
      }
      this.deleteUserData.showDeleteUser = true;
    },
    showRevokeDevice(device) {
      if (this.user.state === "DT") {
        this.$notify({
          message: "Invalid Action For Deleted User",
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return;
      }
      this.revoke.currentDevice = device;
      this.revoke.showRevokeDeviceDialog = true;
    },
    closeRevokeDialog() {
      this.revoke.currentDevice = {};
      this.revoke.showRevokeDeviceDialog = false;
      this.getUserDevices();
    },
    showDeviceDetails(device) {
      if (this.user.state === "DT") {
        this.$notify({
          message: "Invalid Action For Deleted User",
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return;
      }
      this.currentDevice = device;
      this.showDeviceDetailsDialog = true;
    },
    hideDeviceDetails() {
      this.currentDevice = {};
      this.showDeviceDetailsDialog = false;
    },
    saveDevice() {
      this.hideDeviceDetails();
      this.getUserDevices();
    },
    goToLogsForDevice(deviceID) {
      this.$router.push({
        name: "Authentication/Authorization Reports",
        query: {
          device_id: deviceID
        }
      });
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }

        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    getUserDetails: async function() {
      const response = await this.$api.getUserDetails({
        params: {
          application_user_pk: this.$route.query.user_pk
        }
      });
      if (response.status !== 200) {
        fetchErrorHandler(response.status, response.statusText, this.$options.name);
      } else {
        this.user.applicationName = response.parsedData.applicationName;
        this.user.devCnt = response.parsedData.dev_cnt;
        this.user.userID = response.parsedData.user_id;
        this.user.username = response.parsedData.username;
        this.user.state = response.parsedData.state;
      }
    },
    getUserLogs: async function() {
      // TODO refactor this function and get logs in one api call
      let response = await this.$api.getLogs({
        params: {
          application_user_pk: this.$route.query.user_pk,
          ratio: "result",
          result: "A"
        }
      });
      this.user.allow = response.parsedData.ratio;

      response = await this.$api.getLogs({
        params: {
          application_user_pk: this.$route.query.user_pk,
          count: "1",
          result: "D"
        }
      });
      this.user.deny = response.parsedData.count;

      response = await this.$api.getLogs({
        params: {
          application_user_pk: this.$route.query.user_pk,
          count: "1",
          push_message__status: "FR"
        }
      });
      this.user.frauds = response.parsedData.count;

      response = await this.$api.getLogs({
        params: {
          application_user_pk: this.$route.query.user_pk,
          last_unsuccessful_login: 1
        }
      });
      this.user.lastUnsuccessfulLogin.date = response.parsedData.last_successful_login;
      this.user.lastUnsuccessfulLogin.count = response.parsedData.count;
    },
    getUserDevices: async function() {
      const response = await this.$api.getUserDevices({
        params: {
          application_user_pk: this.$route.query.user_pk,
          active_only: this.onlyActiveDevices,
        },
      });
      if (response.status !== 200) {
        fetchErrorHandler(response.status, response.statusText, this.$options.name);
      } else {
        this.devices = response.parsedData;
      }
    },
    showHideRevokedDevices: function () {
      this.onlyActiveDevices = !this.onlyActiveDevices;
      this.getUserDevices();
    },
    closeCreateDevice: function() {
      this.createDevice.show = false;
      this.getUserDevices();
    },
    userDeleted(message) {
      this.deleteUserData.showDeleteUser = false;
      this.getUserDetails();
      this.$notify({
        message: message ? message : "User deleted.",
        icon: "info",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success"
      });
    },
    operationFailed(message){
      this.$notify({
        message: message ? message : "Operation Failed.",
        icon: "info",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger"
      });
    },
    unlockDevice: async function (device) {
      const response = await this.$api.editDevice({
        params: {
          application_user_pk: this.$route.query.user_pk,
          device_pk: device.device_pk,
          type: device.type,
          unlock: device.locked,
        },
      });
      if (response.status === 200) {
        device.locked = !device.locked;
      }
    },
  },
  mounted() {
    this.getUserDetails();
    this.getUserLogs();
    this.getUserDevices();
    this.getPolicies();
  }
};
</script>
<style lang="scss" scoped>
.stat-card {
  @media (max-width: 1560px) {
    min-width: 50% !important;
    max-width: 50% !important;
    flex: 0 1 50% !important;
  }
  @media (max-width: 660px) {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 1 100% !important;
  }
}

a {
  .md-icon:hover {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.28);
  }
}

.table-actions {
  float: right;
}

.md-theme-default a:not(.md-button).show-add-user-deleted-app,
.md-theme-default a:not(.md-button).show-add-user-deleted-app:hover {
  color: var(--md-theme-default-primary-on-background, gray) !important;
}

.cursor-class {
  cursor: pointer;
}
</style>
